var map = {
	"./AmEx.png": 74841,
	"./Any.png": 34060,
	"./Default Card.png": 94619,
	"./Diners.png": 8967,
	"./JCB.png": 70707,
	"./MC.png": 40344,
	"./RuPay.png": 16281,
	"./UPI.png": 31682,
	"./Visa.png": 19347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46111;